import {GameSession, QuestionTypeConnect, QuestionTypeNumberScale, QuestionTypeOrder, QuestionTypeSelect, QuestionTypeText} from '../types/gameSession';

type Question = GameSession['question'] | null | undefined;

/** The answer wire format is also the basis for detecting unsaved edits. */
export const getQuestionAnswers = (question: Question): any[] => {
    if (!question) return [];
    switch (question.type) {
        case 'select':
            return (question as QuestionTypeSelect).options.filter(option => option.selected)
                .map(({index, answer}) => ({index, answer: answer ?? null}));
        case 'order':
            return (question as QuestionTypeOrder).options.map(option => option.index);
        case 'connect':
            return (question as QuestionTypeConnect).selected_pairs.map(pair => [...pair]);
        case 'text':
            return (question as QuestionTypeText).options.map(option => ({...option}));
        case 'number_scale': {
            const selected = (question as QuestionTypeNumberScale).options.find(option => option.selected);
            return selected ? [selected.rating] : [null];
        }
        default: return [];
    }
};

export const answerFingerprint = (question: Question): string => {
    let answers = getQuestionAnswers(question);
    if (question?.type === 'select') {
        answers = answers.map(({index, answer}) => ({index, answer: answer ?? ''}))
            .sort((a, b) => a.index - b.index);
    } else if (question?.type === 'connect') {
        answers.sort((a, b) => a[0] - b[0] || a[1] - b[1]);
    } else if (question?.type === 'text') {
        answers = answers.map(({key, value}) => ({key, value: value ?? ''}))
            .sort((a, b) => a.key.localeCompare(b.key));
    }
    return JSON.stringify(answers);
};

export const isQuestionDirty = (question: Question, baseline: string): boolean =>
    answerFingerprint(question) !== baseline;
